import FJTextPreview from '../view/FJTextPreview.jsx';
import { useDispatch, useSelector } from 'react-redux';
import FJActionTextBasedEditingMouseEvent from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditingMouseEvent.js';
import FJEditFloatingPanelContainer from './FJEditFloatingPanelContainer.jsx';
import FJActionTextBasedEditing from '../../../../../redux/action/textBasedEditing/FJActionTextBasedEditing.js';

const FJTextPreviewContainer = () => {
    const dispatch = useDispatch();

    const textPreviewId = useSelector(state => state.textBasedEditing.editTextPreviewId);
    const _onMouseEvent = (eventType, point) => {
        dispatch(FJActionTextBasedEditingMouseEvent.onMouseEventAction(eventType, point));
    };

    const _render = () => {
        dispatch(FJActionTextBasedEditing.renderAction());
    };

    return (
        <>
            <FJTextPreview onMouseEvent={_onMouseEvent} textPreviewId={textPreviewId} render={_render} />
            <FJEditFloatingPanelContainer />
        </>
    );
};

export default FJTextPreviewContainer;
